import axios, { AxiosInstance } from "axios";
import axiosRateLimit from "axios-rate-limit";
import { BaseConnection } from "./_base.connection";

export class RestTypeConnection extends BaseConnection {
	static DEFAULT_MAX_REQUEST_LIMIT = 50;
	static DEFAULT_PER_MILISECOND_LIMIT = 100;
	static DEFAULT_TIMEOUT = 10000;

	axiosConnection: AxiosInstance;

	constructor(baseUrl: string, baseHeaders: any, { additionalHeaders = {}, maxRequestsLimit = RestTypeConnection.DEFAULT_MAX_REQUEST_LIMIT, perMillisecondsLimit = RestTypeConnection.DEFAULT_PER_MILISECOND_LIMIT, timeout = RestTypeConnection.DEFAULT_TIMEOUT, httpsAgent = null } = {}) {
		super();
		this.axiosConnection = this.createAxiosConnection(baseUrl, baseHeaders, additionalHeaders, maxRequestsLimit, perMillisecondsLimit, timeout, httpsAgent);
		return this;
	}

	createAxiosConnection(baseUrl: string, baseHeaders: any, additionalHeaders: any, maxRequestsLimit: number, perMillisecondsLimit: number, timeout: number, httpsAgent: any) {
		const headers: any = {
			...baseHeaders,
			...additionalHeaders
		};

		const instance = axios.create({
			baseURL: baseUrl,
			timeout,
			headers,
			httpsAgent
			// adapter: cacheConfig.adapter
		});

		return axiosRateLimit(instance, { maxRequests: maxRequestsLimit, perMilliseconds: perMillisecondsLimit });
	}

	async exec(method: string, url: string, { params = null, body = null, fullResponse = false, headers = {} } = {}) {
		if (process.env.NODE_ENV !== "production")
			console.log(method, url, params);

		let request = null;
		switch (method) {
			case "GET":
				request = this.axiosConnection.get(url, {
					params,
					headers
				});
				break;
			case "POST":
				request = this.axiosConnection.post(url, body, { headers });

				break;
			case "PUT":
				request = this.axiosConnection.put(url, body, { headers });
				break;
			case "PATCH":
				request = this.axiosConnection.patch(url, body, { headers });
				break;
			case "DELETE":
				request = this.axiosConnection.delete(url, { headers });
				break;

			default:
				return new Promise((resolve, reject) => { reject(`Undefined handler for HTTP method ${method}`); });
		}
		try {
			const response = await request;
			return fullResponse ? response : response.data;
		} catch (error: any) {
			if (error.response)
				// La respuesta fue hecha y el servidor respondió con un código de estado que esta fuera del rango de 2xx
				return Promise.reject(error.response.data ?? error);
			else if (error.request) {
				// La petición fue hecha pero no se recibió respuesta. error.request es una instancia de XMLHttpRequest en el navegador y una instancia de http.ClientRequest en node.js
				delete error.request._currentRequest;
				delete error.request._options;
				delete error.config.httpsAgent;
				return Promise.reject({
					message: error.message ?? "",
					code: error.code ?? "",
					error
				});
			} else
				// Algo paso al preparar la petición que lanzo un Error
				return Promise.reject(error.message ?? error);
		}
		// return request
		// 	.then(response => {
		// 		return fullResponse ? response : response.data;
		// 	})
		// 	.catch(error => {
		// 		if (error.response)
		// 			// La respuesta fue hecha y el servidor respondió con un código de estado que esta fuera del rango de 2xx
		// 			return Promise.reject(error.response.data ?? error);
		// 		else if (error.request) {
		// 			// La petición fue hecha pero no se recibió respuesta. error.request es una instancia de XMLHttpRequest en el navegador y una instancia de http.ClientRequest en node.js
		// 			delete error.request._currentRequest;
		// 			delete error.request._options;
		// 			delete error.config.httpsAgent;
		// 			return Promise.reject({
		// 				message: error.message ?? "",
		// 				code: error.code ?? "",
		// 				error
		// 			});
		// 		} else
		// 			// Algo paso al preparar la petición que lanzo un Error
		// 			return Promise.reject(error.message ?? error);
		// 	});
	}
}